import { Injectable } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';

import { InitConstant } from '../Constant';

import { LogService } from './log.service';
import { StorageService } from './storage.service';

declare var window;

@Injectable({
    providedIn: 'root'
})
export class AuthService
{
    private token = null;
    private user_id = null;
    private device_name = null;
    private isLoggedIn = false;
    private settings = [];

    constructor(
        private log: LogService,
        private storage: StorageService,
        private nav: NavController,
        private platform: Platform
    ) 
    {
    }

    async isAuth()
    {
        await this.getToken();
        await this.getDeviceName();
        this.isLoggedIn = (this.empty(this.token) || this.empty(this.device_name) ? false : true);
        this.log.debug(`isAuth -> `+this.isLoggedIn);
        return this.isLoggedIn;
    }

    async getToken()
    {
        if (this.empty(this.token)) {
              this.token = await this.storage.getData('token')
                    .then(data => {
                          return (this.empty(data) ? null : data);
                    })
                    .catch(e => {
                          this.log.error([`getToken -> failure`, e]);
                          return null;
                    });
        }

        return this.token;
    }

    async setToken(token)
    {
        this.token = token;
        await this.storage.setData('token', token);
    }

    async getUserId()
    {
        if (this.empty(this.user_id)) {
              this.user_id = await this.storage.getData('user_id')
                    .then(data => {
                          return (this.empty(data) ? null : data);
                    })
                    .catch(e => {
                          this.log.error([`getUserId -> failure`, e]);
                          return null;
                    });
        }

        return this.user_id;
    }

    async setUserId(user_id)
    {
        this.user_id = user_id;
        await this.storage.setData('user_id', user_id);
    }

    async getDeviceName()
    {
        if (this.empty(this.device_name)) {
              this.device_name = await this.storage.getData('device_name')
                    .then(data => {
                          return (this.empty(data) ? null : data);
                    })
                    .catch(e => {
                          this.log.error([`getDeviceName -> failure`, e]);
                          return null;
                    });
        }

        return this.device_name;
    }

    async setDeviceName(device_name)
    {
        this.device_name = device_name;
        await this.storage.setData('device_name', device_name);
    }

    async getSettings(key)
    {
        if (this.empty(this.settings[key])) {
              this.settings[key] = await this.storage.getData(key)
                    .then(data => {
                          return (this.empty(data) ? null : data);
                    })
                    .catch(e => {
                          this.log.error([`getSettings -> failure: ${key}`, e]);
                          return null;
                    });
        }

        return this.settings[key];
    }

    async setSettings(key, val)
    {
        this.settings[key] = val;
        await this.storage.setData(key, val);
    }

    async removeSettings(key)
    {
        delete this.settings[key];
        await this.storage.remove(key);
    }

    async removeAllkeywords()
    {
        const keys = await this.storage.getKeys();

        keys.map(async(v) => {
            if (v.indexOf("file_search_word::") == 0) {
                await this.removeSettings(v);
            }
        });
    }

    async redirectToDefault(is_logout)
    {
        if (is_logout) {
            await this.removeAllkeywords();
            this.token = null;
            this.device_name = null;
            this.storage.setData('token', null);
            this.storage.setData('device_name', null);
            this.nav.navigateRoot('/login');
        } else {
            await this.removeAllkeywords();
            this.nav.navigateRoot('/file');
        }
    }

    empty(data: any)
    {
        return data == undefined || data.length == 0 || data == null;
    }

    isSafeCharactor(name, file_flg)
    {
        let regexpNumber1: RegExp = /\/|\\|\?|\"|<|>|\*|\|/;
        let regexpNumber3: RegExp = /^\.\./;
        let regexpNumber4: RegExp = /:/;

        let ret = false;

        if (file_flg == 1) {
            ret = !regexpNumber1.test(name) && !regexpNumber3.test(name) && !regexpNumber4.test(name);
        } else {
            ret = !regexpNumber1.test(name) && !regexpNumber3.test(name);
        }

        return ret;
    }

    replaceCharactor(name)
    {
        let new_text = name;

        new_text = new_text
            .replace(/\//g, "／")
            .replace(/\\/g, "￥")
            .replace(/\?/g, "？")
            .replace(/\"/g, "“")
            .replace(/</g, "＜")
            .replace(/>/g, "＞")
            .replace(/\*/g, "＊")
            .replace(/\|/g, "｜")
            .replace(/:/g, "：")
            .replace(/\.\./g, "．．");

        return new_text;
    }

    getBrowserName()
    {
        const userAgentData = window.navigator.userAgentData;
        let model = null;

        if (userAgentData) {
            const brands = userAgentData.brands;
            for (var i = 0; i < brands.length; i++) {
                const brand = brands[i].brand;
                if (brand.indexOf("Google Chrome") !== -1) {
                    model = "Chrome";
                    break;
                } else if (brand.indexOf("Microsoft Edge") !== -1) {
                    model = "Edge";
                    break;
                } else if (brand.indexOf("Opera") !== -1) {
                    model = "Opera";
                    break;
                }
            }
        } else {
            const userAgent = window.navigator.userAgent.toLowerCase();

            if (userAgent.indexOf("msie") !== -1 || userAgent.indexOf("trident") !== -1) {
                model = "Internet Explorer";
            } else if (userAgent.indexOf("edge") !== -1) {
               model = "Edge";
            } else if (userAgent.indexOf("edg") !== -1) {
                model = "Edge";
            } else if (userAgent.indexOf("chrome") !== -1) {
                model = "Chrome";
            } else if (userAgent.indexOf("safari") !== -1) {
                model = "Safari";
            } else if (userAgent.indexOf("firefox") !== -1) {
                model = "FireFox";
            } else if (userAgent.indexOf("opera") !== -1) {
                model = "Opera";
            }
        }

        return model;
    }

    getUserAgent()
    {
        const userAgentData = window.navigator.userAgentData;

        if (userAgentData) {
            return JSON.stringify(userAgentData)
        } else {
            return window.navigator.userAgent.toLowerCase();

        }
    }

    changeRadio(search, id)
    {
        try {
            const target = `${search}::${id}`
            const allElms = document.getElementsByClassName(search) as HTMLCollectionOf<HTMLElement>;

            for (let i = 0; i < allElms.length; i++) {
                const param = allElms[i].getAttribute('data-radio');

                if (param == target) {
                    allElms[i].classList.add('active');
                } else {
                    allElms[i].classList.remove('active');
                }
            }
        } catch (err) {}
    }
}
